import React from 'react';
import { Link } from 'react-router-dom';
import { BUNDLES } from '../data/mock';
import { useStore } from '../context/StoreContext';

const R = (n) => `R ${n.toFixed(0)}`;

export default function BundlesPage() {
  const { addToCart } = useStore();
  return (
    <div className="fade-in">
      <section className="bg-champagne">
        <div className="mx-auto max-w-7xl px-5 py-16 lg:px-8">
          <p className="eyebrow text-espresso/60">Curated bundles</p>
          <h1 className="mt-2 font-display text-5xl md:text-6xl">Better together.</h1>
          <p className="mt-3 max-w-xl text-espresso/70">Hand-picked sets at a softer price. Beautifully packaged, ready to gift — or keep for yourself.</p>
        </div>
      </section>
      <section className="mx-auto max-w-7xl px-5 py-16 lg:px-8">
        <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
          {BUNDLES.map((b) => (
            <div key={b.id} className="group border border-stone-warm bg-ivory p-5 transition hover:border-gold">
              <div className="aspect-[4/5] overflow-hidden bg-champagne">
                <img src={b.image} alt={b.title} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
              </div>
              <h3 className="mt-5 font-display text-2xl">{b.title}</h3>
              <ul className="mt-2 space-y-1 text-sm text-espresso/70">
                {b.items.map((it) => <li key={it}>— {it}</li>)}
              </ul>
              <div className="mt-5 flex items-center justify-between">
                <div>
                  <p className="text-xl">{R(b.price)}</p>
                  <p className="text-[11px] uppercase tracking-[0.18em] text-gold">Save {R(b.saves)}</p>
                </div>
                <button onClick={() => addToCart(b.id, 1)} className="btn btn-dark">Add to bag</button>
              </div>
            </div>
          ))}
        </div>
        <div className="mt-12 text-center">
          <Link to="/shop" className="eyebrow text-espresso hover:text-gold">Or shop individually →</Link>
        </div>
      </section>
    </div>
  );
}
